import { useState } from "react";
import { useLang } from "../lib/i18n";

export const BeforeAfter = ({ before, after, label, testId }) => {
  const { t } = useLang();
  const [pos, setPos] = useState(50);
  return (
    <figure className="frz-ba" data-testid={testId}>
      <div className="frz-ba-stage">
        <img src={after} alt={`${label} – ${t("after")}`} className="frz-ba-img" />
        <img src={before} alt={`${label} – ${t("before")}`} className="frz-ba-img frz-ba-before" style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }} />
        <div className="frz-ba-line" style={{ left: `${pos}%` }} aria-hidden="true"><span /></div>
        <span className="frz-ba-tag left">{t("before")}</span>
        <span className="frz-ba-tag right">{t("after")}</span>
        <input type="range" min="0" max="100" value={pos} onChange={(e) => setPos(Number(e.target.value))}
          className="frz-ba-range" aria-label={label} data-testid={`${testId}-slider`} />
      </div>
      <figcaption>{label}</figcaption>
    </figure>
  );
};
